import React, {useState} from 'react'
import Button from 'lib/ui/Button'
import Dialog from 'lib/ui/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TestAttendeeSearchField from 'organization/Event/Form/TestTagButton/TestAttendeeSearchField'
import styled from 'styled-components'
import {Attendee} from 'Event/attendee'
import CompletedTestForm from 'organization/Event/Form/WebhookTest/CompletedTestForm'
import {Form} from 'organization/Event/FormsProvider'
import {Answer} from 'Event/SubmissionsProvider'

export default function SelectTestAttendeeDialog(props: {
  visible: boolean
  onClose: () => void
  onSelect: (attendee: Attendee | null, answers: Answer[]) => Promise<void>
  form: Form
}) {
  const {visible, onSelect, onClose, form} = props
  const [value, setValue] = useState<Attendee | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [answers, setAnswers] = useState<Answer[]>([])

  const select = () => {
    if (!value) return

    setLoading(true)
    onSelect(value, answers)
      .then(() => {
        setValue(null)
        onClose()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      PaperProps={{
        style: {
          width: '100%',
          overflow: 'initial',
        },
      }}
    >
      <DialogTitle>Select attendee to test</DialogTitle>
      <DialogContent>
        <Info>Select attendee for the webhook</Info>

        <TestAttendeeSearchField
          onChange={setValue}
          value={value}
          disabled={loading}
        />

        <CompletedTestForm
          form={form}
          answers={answers}
          setAnswers={setAnswers}
        />

        <StyledButton
          variant="contained"
          color="primary"
          aria-label="send test answer"
          disabled={loading || !value}
          onClick={select}
        >
          Send test answer
        </StyledButton>
      </DialogContent>
    </Dialog>
  )
}

const Info = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[4]};
  font-size: 14px;
  font-style: italic;
`

const StyledButton = styled(Button)`
  height: 32px;
  align-self: center;
  font-size: 11px;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`
